import React from 'react';
import { Link } from 'react-router-dom';
import { RoutePaths } from '../../Common/ClientRoutes';

export const SinglePatient = props => {
    return (
        <tr>
            <td>
                <Link to={RoutePaths.PATIENT_DETAILS(props.id)}>{props.name ? props.name : ' '}</Link>
            </td>
            <td />
            <td>{props.email}</td>
            <td />
            <td>{props.pharmacy}</td>
            <td />
            <td>{props.phone}</td>
            <td className="qf-hidden-box">
                <Link to={RoutePaths.EDIT_PATIENT(props.id)}>
                    <i className="fa fa-pencil-square-o" />
                </Link>
            </td>
        </tr>
    );
};



// WEBPACK FOOTER //
// ./src/customModules/Patients/components/Single-patient.js